/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React from "react"
import { Link, Element, Label } from "trux"
import { statHighlight } from "../util/formatter"
import "./TopStatCard.css"

/*
    TopStatCard Props
    - statValue: string required
    - statTitle: string required
    - playerInitials: string optional
    - footer: string optional
*/
export const TopStatCard = (props) => {
    var playerInitials = ""
    if (props["playerInitials"] != null) {
        playerInitials = (
            <Link
                to={props.playerLink}
                className="PlayerAvatar PlayerAvatar--inline u-center-block pointer-cursor"
            >
                {props.playerInitials}
            </Link>
        )
    }

    var footer = ""
    // eslint-disable-next-line eqeqeq
    if (props["footer"] != null) {
        footer = <Element className="stat-footer">{props.footer}</Element>
    }

    return (
        <Element className="TopStatCard">
            {playerInitials}
            <Element className="Stat">
                <Label
                    className={statHighlight(
                        props.statRank,
                        props.playerCount,
                        !props.isTraceFamilyGame
                    )}
                >
                    <Label className="first">1st</Label>
                    {props.statValue}
                </Label>
            </Element>
            <Label type={Label.Type.Body} small className="StatLabel">
                {props.statTitle}
            </Label>
            {footer}
        </Element>
    )
}
